var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageReminder32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Message/Reminder32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconReminder",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#E1001A",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bell",
    transform: "translate(8.500000, 7.500000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,8.5 L1.5,4.5 C1.5,2.49592707 3.29334647,1 5.5,1 C7.70665353,1 9.5,2.49592707 9.5,4.5 L9.5,8.5 L11,11 L0,11 L1.5,8.5 Z",
    id: "Body"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Top",
    cx: 5.5,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,12.5 C4.6547825,12.5 4.05457476,12.1248702 3.73704854,11.5295085 C3.55744679,11.1927552 3.5,10.869617 3.5,10.625 L3.5,10 L7.5,10 L7.5,10.625 C7.5,10.869617 7.44255321,11.1927552 7.26295146,11.5295085 C6.94542524,12.1248702 6.3452175,12.5 5.5,12.5 Z",
    id: "Bottom"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageReminder32);
export default __webpack_public_path__ + "static/media/messageReminder32.da40adfe7c6128053daa62641f46e05a.svg";
export { ForwardRef as ReactComponent };